/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useRef } from "react"
import { Color, ID } from "src/libs/interfaces/layouts"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getContrastColor, getCssDemention } from "src/libs/utilities"
import { ButtonContent, LINKS_DESIGN_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { getClassNameByDesignLinkType } from "src/modules/pe-landing-module/data/utils/getClassNameByDesignLinkType"
import { useAnimated } from "src/modules/pe-landing-module/hooks/useAnimated"
import { useAnimatedStyle } from "src/modules/pe-landing-module/hooks/useAnimatedStyle"
import { getAnimateDelay } from "../../utils/getAnimateDelay"
import { IPrimitiveProps } from "../section/Primitive"
import ContactsEditorForm from "../landing-edit/editors/contacts"

/* Protopia Ecosystem component */ 
const ButtonPrimitive = (props: IPrimitiveProps): JSX.Element => { 
    const primitive: ButtonContent = ( props.primitive || {} ) as ButtonContent
    const id = useMemo(() => primitive.id  || `${Math.random()}`.replace("." , ""), [])
    return <div className={`m-1 flex-centered ${props.primitive?.className }`}> 
        <div className="button-primitive-cont"> 
            <ContactsEditorForm i={props.i || 0} item={primitive} items={props.primitive?.items || []} >                                
                <ButtonContainer {...props} id={id}>
                    {
                        !!primitive.image ? <img className={ `button-primitive-image` } src={primitive.image} alt="" width={primitive.imageWidth} height={primitive.imageHeight} /> : <div></div>
                    }
                    {
                        !!primitive.icon 
                            ? 
                            <div 
                                className={ `button-primitive-icon ${primitive.icon}` } 
                                style={{ color: primitive.text_color, fontSize: primitive.font_size, letterSpacing: primitive.letter_spacing || 3 }}
                            /> 
                            : 
                            <div></div>
                    } 
                    
                    {
                        !!primitive.label 
                            ? 
                            <div className="button-primitive-label mx-auto" style={{...primitive.labelStyle, color: primitive.text_color, fontSize: primitive.font_size}}>
                                { primitive.label }
                            </div> 
                            :
                            <></>
                    }
                    {
                        !!primitive.rightIcon ? <div className={ `button-primitive-icon ${primitive.rightIcon}` } /> : <div></div>
                    } 
                </ButtonContainer>
            </ContactsEditorForm>
        </div>  
    </div>  
}
export default ButtonPrimitive

interface IButtonContainerProps extends IPrimitiveProps{
    children: JSX.Element[]
    id: ID
    onClick?: () => void
}
const ButtonContainer = (props: IButtonContainerProps): JSX.Element => {
    const primitive: ButtonContent = ( props.primitive || {} ) as ButtonContent  
     
    useEffect(() => {
        addCSSClass(
            `button-${props.id}`,
            `.button-${props.id} {
                ${ getButtonColors( primitive.button_color, primitive.design_type ) }
                ${ primitive.border_width ? `border-width: ${ primitive.border_width || 3 }px!important;` : `border-width: 3px;` }
                ${ primitive.style?.margin ? `margin: ${getCssDemention( primitive.style.margin )}!important;` : ``}
                ${ primitive.style?.marginLeft ? `margin-left: ${getCssDemention( primitive.style.marginLeft )}!important;` : `margin-left: 0;`}
                ${ primitive.style?.marginRight ? `margin-right: ${getCssDemention( primitive.style.marginRight )}!important;` : `margin-right: 0;`}
                ${ primitive.style?.marginTop ? `margin-top: ${getCssDemention( primitive.style.marginTop  )}!important;` : `margin-top: 10px;`}
                ${ primitive.style?.marginBottom ? `margin-bottom: ${getCssDemention( primitive.style.marginBottom )}!important;` : `margin-bottom: 10px;`}
                padding: 5px 20px;
            }
            .button-${props.id}:hover  {
                ${ getButtonActiveColors( primitive.button_color, primitive.design_type ) }
            }
            .button-${props.id}:active{
                ${ primitive.style?.marginTop ? `margin-top: ${getCssDemention( primitive.style.marginTop )}!important;` : `margin-top: 11px;`}
                ${ primitive.style?.marginBottom ? `margin-bottom: ${getCssDemention( primitive.style.marginBottom )}!important;` : `margin-bottom: 9px;`}
            }`
        )
        return () => {
            removeCSSClass(`button-${props.id}`)
        }
    }, []) 
    const animated_delay    = getAnimateDelay( primitive.animated_delay, props.i ) 
    const ref               = useRef(null)
    useAnimated( ref, animated_delay )
    const animate           = useAnimatedStyle(primitive, props.i || 0)
    const design_type       = primitive.design_type || LINKS_DESIGN_TYPE.MINIMAL
    if( !!primitive.url ) {
        return <a 
            className={` button-primitive button-${props.id} ${getClassNameByDesignLinkType( design_type )} ${primitive.className || ""} ${animate}`} 
            style={{ ...primitive.style, width: primitive.width, height: primitive.height, }}
            href={ primitive.url } 
            target="_blank" 
            data-button-id={props.id}
            data-design-type={design_type}
            data-primitive-type={primitive["data-primitive-type"]}
            rel="noreferrer"
            ref={ref}
            onClick={props.onClick}
        >
            { props.children }
        </a>
    }
    return <div 
        className={` button-primitive button-${props.id} ${getClassNameByDesignLinkType( design_type )} ${primitive.className || ""} ${animate}`} 
        style={{ ...primitive.style, width: primitive.width, height: primitive.height, }}
        data-button-id={props.id}
        data-design-type={design_type}
        data-primitive-type={primitive["data-primitive-type"]}
        ref={ref}
        onClick={props.onClick}
    >
        { props.children }
    </div>
}

export const getButtonColors = (button_color?: Color, design_type : LINKS_DESIGN_TYPE = LINKS_DESIGN_TYPE.MINIMAL ): string => {
    // if(!button_color) return ''
    let clr = button_color    
    switch (design_type) {
        case LINKS_DESIGN_TYPE.SQUARE:
        case LINKS_DESIGN_TYPE.ROUND:
        case LINKS_DESIGN_TYPE.SMALL:
        case LINKS_DESIGN_TYPE.SMALL_ROUND:
            return `
                background-color: ${clr}!important;
                color: ${getContrastColor(clr)}!important;
                border-color: ${clr}!important; 
            `
        case LINKS_DESIGN_TYPE.MINIMAL:
            return `
                background-color: transparent!important; 
                border-color: transparent!important;
                color: var(--force-contast-color)!important; 
            `
        case LINKS_DESIGN_TYPE.ROUND_OUTLINE_BW:
        case LINKS_DESIGN_TYPE.OUTLINE_BW:
        case LINKS_DESIGN_TYPE.SMALL_OUTLINE_BW:
            return `
                background-color: transparent!important; 
                border-color: var(--force-contast-color)!important;
                color: var(--force-contast-color)!important; 
            `
        case LINKS_DESIGN_TYPE.OUTLINE:
        case LINKS_DESIGN_TYPE.SMALL_MINIMAL:
        case LINKS_DESIGN_TYPE.SMALL_OUTLINE:
        case LINKS_DESIGN_TYPE.ROUND_OUTLINE:
        default:
            return `
                border-color: ${clr}!important;
                color: ${ clr }!important;
                background-color: transparent!important; 
            `
    } 
}
export const getButtonActiveColors = (button_color?: Color, design_type : LINKS_DESIGN_TYPE = LINKS_DESIGN_TYPE.MINIMAL ): string => {
    // if(!button_color) return ''
    let clr = button_color    
    switch (design_type) {
        case LINKS_DESIGN_TYPE.SQUARE:
        case LINKS_DESIGN_TYPE.ROUND:
        case LINKS_DESIGN_TYPE.SMALL:
        case LINKS_DESIGN_TYPE.SMALL_ROUND:
            return `
                background-color: ${clr}!important;
                color: ${getContrastColor(clr)}!important;
                border-color: ${clr}!important; 
            `
        case LINKS_DESIGN_TYPE.MINIMAL:
            return `
                background-color: var(--force-contast-color)!important; 
                border-color: var(--force-contast-color)!important;
                color: var(--force-plain-color)!important; 
            `
        case LINKS_DESIGN_TYPE.ROUND_OUTLINE_BW:
        case LINKS_DESIGN_TYPE.OUTLINE_BW:
        case LINKS_DESIGN_TYPE.SMALL_OUTLINE_BW:
            return `
                background-color: var(--force-contast-color)!important; 
                border-color: var(--force-contast-color)!important;
                color: var(--force-plain-color)!important; 
            `
        case LINKS_DESIGN_TYPE.OUTLINE:
        case LINKS_DESIGN_TYPE.SMALL_MINIMAL:
        case LINKS_DESIGN_TYPE.SMALL_OUTLINE:
        case LINKS_DESIGN_TYPE.ROUND_OUTLINE:
        default:
            return `
                background-color: ${clr}!important;
                color: ${getContrastColor(clr)}!important;
                border-color: ${clr}!important; 
            `
    } 
}